"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCrmDateValue = void 0;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})(?:[T ][\d:.+\-Z]*)?$/;
const JS_DATE_STRING = /^([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d{2}) (\d{4}) /;
const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const toIsoDate = (year, month, day) => {
    if (year < 1) {
        return null;
    }
    const date = new Date(Date.UTC(2000, month - 1, day));
    date.setUTCFullYear(year);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
        return null;
    }
    return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};
const normalizeCrmDateValue = (raw) => {
    const trimmed = raw.trim();
    const iso = ISO_DATE.exec(trimmed);
    if (iso) {
        return toIsoDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));
    }
    const jsDate = JS_DATE_STRING.exec(trimmed);
    if (jsDate) {
        const month = MONTHS.indexOf(jsDate[2]) + 1;
        if (month === 0 || !WEEKDAYS.includes(jsDate[1])) {
            return null;
        }
        return toIsoDate(Number(jsDate[4]), month, Number(jsDate[3]));
    }
    return null;
};
exports.normalizeCrmDateValue = normalizeCrmDateValue;
